// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"375":"eager-p0-core-components","551":"eager-p1-core-slices"}[chunkId] + "." + {"375":"987237e8eb5be77cd32c","551":"5876bea16144fa0ae815"}[chunkId] + ".css";
};